var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import cx from 'clsx';
import { visuallyHidden } from '../../css/accessibility.css';
import { useClientSideRendering } from '../../utils/rendering';
import { renderIcon } from '../button/Button';
import { innerSpanVariants, sizeWithIconVariants } from '../button/Button.css';
import { baseStyles, borderVariants, onlyIconStyles } from './SiteAuxiliaryButton.css';
export const SiteAuxiliaryButton = React.forwardRef(function SiteAuxiliaryButton(_a, ref) {
    var { as, children, className, hideLabel = false, iconPrefix, iconSuffix, size = 'small', type, withBorder = true } = _a, rest = __rest(_a, ["as", "children", "className", "hideLabel", "iconPrefix", "iconSuffix", "size", "type", "withBorder"]);
    const Component = as || 'button';
    const { isClient } = useClientSideRendering();
    return (_jsxs(Component, Object.assign({}, rest, { className: cx(baseStyles, borderVariants[withBorder ? 'withBorder' : 'withoutBorder'], isClient && (hideLabel ? onlyIconStyles : sizeWithIconVariants[size]), className), ref: ref, type: type !== null && type !== void 0 ? type : (as ? undefined : 'button'), children: [iconPrefix && renderIcon(iconPrefix), _jsx("span", { className: cx(isClient && hideLabel && visuallyHidden, innerSpanVariants[size]), children: children }), iconSuffix && renderIcon(iconSuffix)] })));
});
